// @flow
export const ORGS_TYPES_FILTER_CLEAR: 'reports/ORGS_TYPES_FILTER_CLEAR' = 'reports/ORGS_TYPES_FILTER_CLEAR';
export const ORGS_TYPES_FILTER_DELETE: 'reports/ORGS_TYPES_FILTER_DELETE' = 'reports/ORGS_TYPES_FILTER_DELETE';
export const ORGS_TYPES_FILTER_SET: 'reports/ORGS_TYPES_FILTER_SET' = 'reports/ORGS_TYPES_FILTER_SET';
export const ORGS_TYPES_FILTER_UPDATE: 'reports/ORGS_TYPES_FILTER_UPDATE' = 'reports/ORGS_TYPES_FILTER_UPDATE';
